import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DashboardComponent } from './dashboard/dashboard.component';
import { publicApiLeaveGuard } from './settings/public-api/public-api-leave.guard';

const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
  },
  {
    path: 'pages/comment-field',
    loadComponent: () =>
      import('./comment-field/comment-field.component').then(
        (m) => m.CommentFieldComponent
      ),
  },
  {
    path: 'settings/users',
    loadComponent: () => import('./settings/users/users.component'),
  },
  {
    path: 'settings/firm/:id',
    loadComponent: () => import('./settings/firm/firm.component'),
  },
  {
    path: 'settings/teams',
    loadComponent: () => import('./settings/teams/teams.component'),
  },
  {
    path: 'commercial/opportunity',
    loadComponent: () =>
      import('./commercial/opportunity/opportunity.component'),
  },
  {
    path: 'my-folders',
    loadComponent: () => import('./my-folders/my-folders.component'),
  },
  {
    path: 'my-contacts',
    loadComponent: () => import('./my-contacts/my-contacts.component'),
  },
  {
    path: 'settings/folders/:id',
    loadComponent: () => import('./settings/folders/folders.component'),
  },
  {
    path: 'settings/variables',
    loadComponent: () => import('./settings/variables/variables.component'),
  },
  {
    path: 'my-folders/view-folder/:idFolder',
    loadComponent: () =>
      import('./my-folders/view-folder/view-folder.component'),
  },
  {
    path: 'commercial/contract',
    loadComponent: () =>
      import('./commercial/opportunity/contract-form/contract-form.component'),
  },
  {
    path: 'settings/applications',
    loadComponent: () =>
      import('./settings/manage-application/manage-application.component'),
  },
  {
    path: 'settings/public-api',
    canDeactivate: [publicApiLeaveGuard],
    loadComponent: () => import('./settings/public-api/public-api.component'),
  },
  {
    path: 'my-invoices',
    loadComponent: () => import('./my-invoices/my-invoices.component'),
  },
  {
    path: 'mass-processing',
    loadComponent: () => import('./mass-processing/mass-processing.component'),
  },
  {
    path: 'pennylane-update-invoices/:providerId',
    loadComponent: () =>
      import('./pennylane-update-invoices/pennylane-update-invoices.component'),
  },
  {
    path: 'settings/ldm-model',
    loadComponent: () => import('./settings/ldm-model/ldm-model.component'),
  },
  {
    path: 'settings/tasks',
    loadComponent: () => import('./settings/tasks/tasks.component'),
  },
  {
    path: 'settings/file-assignment',
    loadComponent: () =>
      import('./settings/file-assignment/file-assignment.component'),
  },
  {
    path: 'planning',
    loadComponent: () => import('./planning/planning.component'),
  },
  {
    path: 'task-tracking',
    loadComponent: () => import('./task-tracking/task-tracking.component'),
  },
  {
    path: 'deadlines',
    loadComponent: () => import('./deadline/deadline.component'),
  },
  {
    path: 'monitoring-tasks',
    loadComponent: () => import('./monitoring-task/monitoring-task.component'),
  },
  {
    path: 'monitoring-deadlines',
    loadComponent: () =>
      import('./monitoring-deadline/monitoring-deadline.component'),
  },
  {
    path: 'impots_gouv',
    loadComponent: () => import('./impots_gouv/messaging.component'),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'messagerie',
      },
      {
        path: 'messagerie',
        loadComponent: () => import('./impots_gouv/impots-gouv-messages-page.component'),
      },
      {
        path: 'cfe',
        loadComponent: () => import('./impots_gouv/impots-gouv-cfe-page.component'),
      },
      {
        path: 'taxe-fonciere',
        loadComponent: () => import('./impots_gouv/impots-gouv-taxe-fonciere-page.component'),
      },
    ],
  },
  {
    path: 'billing-center',
    loadComponent: () => import('./billing-center/billing-center.component'),
  },
  {
    path: 'my-tasks',
    loadComponent: () => import('./my-tasks/my-tasks.component'),
  },
  {
    path: 'notification-preferences',
    loadComponent: () =>
      import('./notification-preferences/notification-preferences.component'),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {}
